import config from '@core/config';

/**
 * Transform a path into a full environment-specific URL.
 * @param path The path to transform into a full URL.
 * @returns A full environment-specific URL.
 */
export const transformLinkDomain = (path: string): string => {
  return new URL(config.publicUrl, config.baseUrl).toString().replace(/\/$/, '') + path;
};
